<div class="useNgDeep">
  <nz-form-item style="width: 100%">
    <nz-form-control
      nzSpan="24"
      [nzValidateStatus]="valid"
      nzHasFeedback
      nzErrorTip="You should to input Rate"
    >
      <nz-input-wrapper nzSuffix="USD" nzPrefix="$">
        <input type="text" nz-input (blur)="onlyNumberValue()" [(ngModel)]="model" />
      </nz-input-wrapper>
    </nz-form-control>
    @if (taxInclusive) {
      <div nz-tooltip nzTooltipPlacement="top" nzTooltipTitle="Including Taxes">
        Raw: {{ +model - (model * taxRate) / (100 + taxRate) | currency }} Taxes:
        {{ (+model * taxRate) / (100 + taxRate) | currency }} ({{ taxRate }}%)
      </div>
    } @else {
      <div nz-tooltip nzTooltipPlacement="top" nzTooltipTitle="Excluding Taxes">
        Taxes: {{ (+model * +taxRate) / 100 | currency }} ({{ taxRate }}%) Total:
        {{ +model + (model * taxRate) / 100 | currency }}
      </div>
    }
  </nz-form-item>
</div>
